import { customersApi, locationsManagementApi } from '@/api';
import { laboratories } from '@/config/constants';

const stabilityScheduleFilters = [
  {
    name: 'customerId',
    label: 'customerIdOrName',
    type: 'autocomplete',
    whereOperator: '=',
    autocompleteSearch: async (queryString, cb) => {
      const customersResponse = await customersApi.autocompleteFetch(
        'name',
        queryString,
        false,
        true
      );
      const filteredResults = customersResponse.data.map((c) => ({
        label: `${c.id} ${c.name}`,
        value: c.id,
      }));
      cb(filteredResults);
    },
  },
  {
    name: 'groupingId',
    label: 'grouping',
    type: 'text',
    whereOperator: '=',
  },
  {
    name: 'orderId',
    label: 'orderId',
    type: 'text',
    whereOperator: '=',
  },
  {
    name: 'stabilityName',
    label: 'stability.name',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'laboratory',
    label: 'department',
    type: 'select',
    whereOperator: '=',
    options: [
      { value: laboratories.CHIM, label: 'enums.laboratories.CHIM' },
      { value: laboratories.MICR, label: 'enums.laboratories.MICR' },
    ],
  },
  {
    name: 'locationId',
    label: 'locationIdOrName',
    type: 'autocomplete',
    whereOperator: '=',
    autocompleteSearch: async (queryString, cb) => {
      const locationsResponse = await locationsManagementApi.autocompleteFetch(
        'name',
        queryString,
        false,
        true
      );
      const filteredResults = locationsResponse.data.map((c) => ({
        label: c.name,
        value: c.id,
      }));
      cb(filteredResults);
    },
  },
];

export default stabilityScheduleFilters;
